import { createSlice } from '@reduxjs/toolkit';

import { determineIdType } from '../utils/idTypesHelper';

const initialState = {
    id: '',
    idType: 'unknown',
    personType: 'N',
    isForeigner: false,
    error: '',
};

const idSlice = createSlice({
    name: 'id',
    initialState,
    reducers: {
        setIdType: (state, action) => {
            state.id = action.payload.id;
            state.isForeigner = action.payload.isForeigner || false;
            state.personType = action.payload.personType;
            state.idType = determineIdType(state); // Determine ID type dynamically
            if (!state.idType) {
                state.error = 'Documento de identidad inválido';
            } else {
                state.error = '';
            }
        },
    },
});

export const { setIdType } = idSlice.actions;

// Selectors
export const selectId = (state) => state.id.id;
export const selectIdType = (state) => state.id.idType;
export const selectIdPersonType = (state) => state.id.personType;
export const selectIdIsForeigner = (state) => state.id.isForeigner;
export const selectIdError = (state) => state.id.error;

export default idSlice.reducer;
